import { CategoryTab } from "@/design-system/Tabs/CategoryTab";
import { useTranslation } from "@repo/shared/i18n";
import { evolvedPlayersSelector } from "@repo/shared/redux";
import { useSelector } from "react-redux";
import { useMatch, useNavigate } from "react-router";

export const MyEvolvedTabs = () => {
  const { t } = useTranslation("evolutions");
  const navigate = useNavigate();
  const isSaved = !!useMatch("/evolutions/my-evolutions/saved");
  const { myEvolvedPlayers, savedEvolutionPlayers } = useSelector(
    evolvedPlayersSelector,
  );

  const tabs = [
    {
      value: "players",
      label: `${t("myEvolutions.tabs.players")} (${myEvolvedPlayers?.length ?? 0})`,
    },
    {
      value: "saved",
      label: `${t("myEvolutions.tabs.saved")} (${savedEvolutionPlayers?.length ?? 0})`,
    },
  ];

  // The SBC list's category row. On desktop -ml-2 lines the words up with
  // the cards; touch shows a filled pill, which needs the room.
  return (
    <div className="flex items-center gap-x-2 touch-device:-ml-2">
      {tabs.map((tab) => (
        <CategoryTab
          key={tab.value}
          label={tab.label}
          isActive={(tab.value === "saved") === isSaved}
          onClick={() => navigate(`/evolutions/my-evolutions/${tab.value}`)}
        />
      ))}
    </div>
  );
};
